import { TrustHolderDto } from "../../generated/api";

export const GET_TRUSTS = "GET_TRUSTS";
export const GET_TRUST_HOLDERS = "GET_TRUST_HOLDERS";
export const SET_TRUSTS = "SET_TRUSTS";
export const SET_UPLOAD_CA = "SET_UPLOAD_CA";
export const SET_UPLOAD_TRUST_HOLDER = "SET_UPLOAD_TRUST_HOLDER";
export const DELETE_CA = "DELETE_CA";
export const DELETE_TRUST_HOLDER = "DELETE_TRUST_HOLDER";
export const DELETE_TRUST_HOLDER_MODAL = "DELETE_TRUST_HOLDER_MODAL";
export const DELETE_CA_MODAL = "DELETE_CA_MODAL";
export const DOWNLOAD_CA = "DOWNLOAD_CA";
export const SET_TRUST_HOLDERS = "SET_TRUST_HOLDERS";
export const SET_ERROR = "SET_ERROR";

export const setTrusts = (trusts: any) => ({
  type: SET_TRUSTS,
  trusts,
});

export const setUploadCa = () => ({
  type: SET_UPLOAD_CA,
});

export const setUploadTrustHolder = () => ({
  type: SET_UPLOAD_TRUST_HOLDER,
});

export const deleteCa = () => ({
  type: DELETE_CA,
});

export const downloadCa = (file: any) => ({
  type: DOWNLOAD_CA,
  file,
});

export const deleteCaModal = () => ({
  type: DELETE_CA_MODAL,
});

export const deleteTrustHolder = () => ({
  type: DELETE_TRUST_HOLDER,
});

export const deleteTrustHolderModal = () => ({
  type: DELETE_TRUST_HOLDER_MODAL,
});

export const setTrustHolders = (trustHolders: TrustHolderDto[]) => ({
  type: SET_TRUST_HOLDERS,
  trustHolders,
});

export const setError = (error: any) => ({
  type: SET_ERROR,
  error,
});

const initialState = {};

export const trustReducer = (state = initialState, action: any) => {
  const { trusts } = action;
  const { trustHolders } = action;
  const { error } = action;

  switch (action.type) {
    case SET_TRUSTS:
      return { ...state, trusts: trusts };
    case SET_TRUST_HOLDERS:
      return { ...state, trustHolders: trustHolders };
    case SET_ERROR:
      return { ...state, error: error };
    default:
      return state;
  }
};
